import type { Form } from '../../../../common/types/form';
import type { Child } from '../../../../common/types/child';

const moveOutDataForm: Form<Child> = {
  key: 'moveOutData',
  fields: [
    {
      key: 'moveOutNotice',
      label: 'Info / Sonstiges',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default moveOutDataForm;
